/**
 * Image Gallery Grid + Lightbox
 * File: assets/image-gallery-grid.js
 *
 * Reads config from data attributes on #igg-[sectionId]:
 *   data-section-id  – the Shopify section ID
 *   data-total-images – total number of image blocks
 */
(function () {
  /* ─── Find all gallery instances on the page ─── */
  var galleries = document.querySelectorAll('[data-section-id][data-total-images]');
  for (var g = 0; g < galleries.length; g++) {
    initGallery(galleries[g]);
  }

  function initGallery(sectionEl) {
    var S     = sectionEl.getAttribute('data-section-id');
    var TOTAL = parseInt(sectionEl.getAttribute('data-total-images'), 10);
    if (!S || TOTAL === 0) return;

    /* ─── DOM references ──────────────────── */
    var lb        = document.getElementById('iggLb-' + S);
    var lbTrack   = document.getElementById('iggTrack-' + S);
    var lbVP      = document.getElementById('iggViewport-' + S);
    var lbClose   = document.getElementById('iggClose-' + S);
    var lbPrev    = document.getElementById('iggPrev-' + S);
    var lbNext    = document.getElementById('iggNext-' + S);
    var lbCounter = document.getElementById('iggCounter-' + S);

    var current     = 0;
    var touchStartX = 0;
    var touchStartY = 0;
    var isDragging  = false;
    var MOBILE_BP   = 768;
    var MOBILE_GAP  = 10;
    var PEEK_RATIO  = 0.85; /* 85% of viewport = active slide */

    /* ─── Helpers ─────────────────────────── */
    function isMobile() {
      return window.innerWidth < MOBILE_BP;
    }

    function slideWidth() {
      if (!lbVP) return 0;
      var vw = lbVP.offsetWidth;
      if (isMobile()) {
        /* Fractional slide: 85% of viewport width */
        return Math.floor(vw * PEEK_RATIO);
      }
      return vw;
    }

    function updateTrack(animate) {
      if (!lbTrack) return;
      lbTrack.style.transition = animate
        ? 'transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
        : 'none';

      var sw = slideWidth();
      var offset;
      if (isMobile()) {
        /* Center the active slide by offsetting half the peek space */
        var vpWidth = lbVP.offsetWidth;
        var peekPad = (vpWidth - sw) / 2;
        offset = current * (sw + MOBILE_GAP) - peekPad;
      } else {
        offset = current * sw;
      }
      lbTrack.style.transform = 'translateX(-' + offset + 'px)';

      if (lbPrev) lbPrev.disabled = current <= 0;
      if (lbNext) lbNext.disabled = current >= TOTAL - 1;
      if (lbCounter) lbCounter.textContent = (current + 1) + ' / ' + TOTAL;
    }

    function setSlideSizes() {
      if (!lbTrack) return;
      var w = slideWidth();
      var slides = lbTrack.querySelectorAll('.igg-lb__slide');
      for (var i = 0; i < slides.length; i++) {
        slides[i].style.width = w + 'px';
      }
    }

    /* ─── Open / Close ────────────────────── */
    function open(index) {
      current = Math.max(0, Math.min(index, TOTAL - 1));
      lb.classList.add('igg-lb--open');
      lb.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setSlideSizes();
      updateTrack(false);
      if (lbClose) lbClose.focus();
    }

    function close() {
      lb.classList.remove('igg-lb--open');
      lb.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function goTo(index) {
      current = Math.max(0, Math.min(index, TOTAL - 1));
      updateTrack(true);
    }

    /* ─── Grid click → open lightbox ──────── */
    var thumbs = sectionEl.querySelectorAll('[data-igg-index]');
    for (var i = 0; i < thumbs.length; i++) {
      (function (el) {
        el.addEventListener('click', function () {
          open(parseInt(el.getAttribute('data-igg-index'), 10));
        });
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            open(parseInt(el.getAttribute('data-igg-index'), 10));
          }
        });
      })(thumbs[i]);
    }

    /* ─── Lightbox controls ───────────────── */
    if (lbClose) lbClose.addEventListener('click', close);
    if (lbPrev)  lbPrev.addEventListener('click', function () { goTo(current - 1); });
    if (lbNext)  lbNext.addEventListener('click', function () { goTo(current + 1); });

    /* Click backdrop to close */
    if (lb) {
      lb.addEventListener('click', function (e) {
        if (e.target === lb) close();
      });
    }

    /* ─── Keyboard navigation ─────────────── */
    document.addEventListener('keydown', function (e) {
      if (!lb || !lb.classList.contains('igg-lb--open')) return;
      if (e.key === 'ArrowLeft')  goTo(current - 1);
      if (e.key === 'ArrowRight') goTo(current + 1);
      if (e.key === 'Escape')     close();
    });

    /* ─── Touch swipe (mobile lightbox) ───── */
    if (lbTrack) {
      lbTrack.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });

      lbTrack.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        var dy = e.changedTouches[0].clientY - touchStartY;
        /* Only trigger if horizontal swipe is dominant */
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) goTo(current + 1);
          else goTo(current - 1);
        }
      }, { passive: true });

      /* Mouse drag for desktop */
      lbTrack.addEventListener('mousedown', function (e) {
        touchStartX = e.clientX;
        isDragging = true;
        e.preventDefault();
      });
      document.addEventListener('mouseup', function (e) {
        if (!isDragging) return;
        isDragging = false;
        if (!lb || !lb.classList.contains('igg-lb--open')) return;
        var dx = e.clientX - touchStartX;
        if (Math.abs(dx) > 40) {
          if (dx < 0) goTo(current + 1);
          else goTo(current - 1);
        }
      });
    }

    /* ─── Resize handling ─────────────────── */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (lb && lb.classList.contains('igg-lb--open')) {
          setSlideSizes();
          updateTrack(false);
        }
      }, 100);
    });
  }
})();
